import React from 'react';
import { CartCheckout } from 'cart';
import CartContent from 'components/Cart/CartContent';
import CartGiftOrCoupon from 'components/Cart/CartGiftOrCoupon';
import CartSmsNotification from 'components/Cart/CartSmsNotification';
import CartTotal from 'components/Cart/CartTotal';
import DeadlineCounter from 'components/Cart/DeadlineCounter';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { PaymentMethodType } from 'types/paymentMethodType';
import './CartContainer.scss';
function CartContainer({ show, cartNotEmpty, oneClickCheckoutEnabled, paymentMethodTypeIsCreditCard, }) {
    const containerClass = classNames({
        'cart-container': true,
        'cart-container--show': show,
    });
    return (React.createElement("div", { className: containerClass },
        React.createElement(DeadlineCounter, null),
        React.createElement(CartContent, null),
        cartNotEmpty && React.createElement(CartTotal, null),
        cartNotEmpty && oneClickCheckoutEnabled && (React.createElement(React.Fragment, null,
            React.createElement(CartGiftOrCoupon, null),
            React.createElement(CartSmsNotification, null))),
        React.createElement(CartCheckout, null)));
}
CartContainer.propTypes = {
    cartNotEmpty: PropTypes.bool,
    show: PropTypes.bool,
    oneClickCheckoutEnabled: PropTypes.bool,
    dispatch: PropTypes.func.isRequired,
};
const mapStateToProps = ({ ui, cart, features, checkout }) => {
    return {
        cartNotEmpty: cart.products.length > 0,
        oneClickCheckoutEnabled: features.oneClickCheckoutEnabled,
        show: ui.showCart,
        paymentMethodTypeIsCreditCard: checkout.paymentMethodType === PaymentMethodType.CREDIT_CARD,
    };
};
export default connect(mapStateToProps)(CartContainer);
